import React, { useEffect, useState } from 'react';
import { getPopularMovies, getPopularTvShows } from '../../services/tmdbApi';
import MovieCard from '../../components/MovieCard';
import Spinner from '../../components/Spinner';
import ErrorMessage from '../../components/ErrorMessage';
import './style.css';

const Home = () => {
	const [popularMovies, setPopularMovies] = useState([]);
	const [popularTvShows, setPopularTvShows] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fecthData = async () => {
			try {
				const movies = await getPopularMovies();
				const tvShows = await getPopularTvShows();

				// TMDb's popular endpoints can sometimes return non-movies/TV.
				// Let's filter to ensure we only get items with a poster_path for display.
				const filteredMovies = movies.filter(movie => movie.poster_path); 
				const filteredTvShows = tvShows.filter(show => show.poster_path);

				setPopularMovies(filteredMovies);
				setPopularTvShows(filteredTvShows);
				setLoading(false);
			} catch (err) {
				setError('Failed to fetch data. Please check your API key and network connection.');
				setLoading(false);
			}
		}

		fecthData();
	}, []); // Empty dependency array means this runs once on component mount

	if (loading) {
		return (
			<div className='page-container'>
				<Spinner />
				<p>Loading...</p>
			</div>
		);
	}

	if (error) {
		return (
			<div className='page-container'>
				<ErrorMessage message={error} />
				<p>Loading...</p>
			</div>
		);
	}

	return (
		<div className='page-container'>
			<h1 className='page-heading'>Latest & Popular</h1>
			<h2 className='page-subHeading'>Popular Movies</h2>
			<div className='card-grid'>
				{popularMovies.map(movie => (
					<MovieCard key={movie.id} movie={{ ...movie, media_type: 'movie' }} /> // Explicitly add media_type
				))}
			</div>

			<h2 className='page-subHeading'>Popular TV Shows</h2>
			<div className='card-grid'>
				{popularTvShows.map(tvShow => (
					<MovieCard key={tvShow.id} movie={{ ...tvShow, media_type: 'tv' }} /> // Explicitly add media_type
				))}
			</div>
		</div>
	)
}

export default Home;